// @flow

export default {
  wizard: {
    next: 'Næste',
    back: 'Tilbage',
    skip: 'Springe',
    sort: 'Sortere',
    sorting: {
      'utility:desc': 'Det bedste resultat',
      'price:asc': 'Prisen stigende',
      'price:desc': 'Pris falder ned',
      'created_at:desc': 'Nyeste',
      'customer_rating:desc': 'Kundevurdering'
    },
    clickToAddFiles: 'Klik for at tilføje dine filer eller slippe dem her.',
    searchFor: 'Søge efter ...',
    noSearchResults: 'Desværre har vi ikke fundet nogen passende muligheder. Søg igen.',
    loadMoreAnswerOptions: 'Ingen passende mulighed her? Vis alle indstillinger.',
    noRecommendationDescription: 'Åh nej, desværre kunne vi ikke finde nogen produkter, der passer til dine behov.',
    noRecommendationDescription2: 'Genstart produktrådgiveren.',
    noRecommendationRestartButtonTitle: 'Genstart',
    noRecommendationCloseButtonTitle: 'Tæt',
    removeFile: 'Fjern fil'
  },
  chatbot: {
    selectAll: 'Vælg alle',
    none: 'Ingen',
    confirmButton: 'Bekræfte',
    customerServiceInputPlaceholder: 'Skriv en besked ...',
    you: 'Du',
    restart: 'Start igen',
    close: 'Tæt',
    send: 'Sende',
    supportChat: 'Supportchat',
    honeypot: 'Lad venligst dette felt stå tomt',
    scrollToTheLatestMessage: 'Rul til den seneste besked',
    removeFile: 'Fjern fil'
  },
  product: {
    loadMore: 'Indlæs flere produkter',
    badgeTitle: 'Vores anbefaling',
    ctaButtonTitle: 'Oplev produkt',
    matchingPanelTitle: 'Skræddersyet til dine behov',
    bestFit: 'Bedste pasform',
    bestPrice: 'Bedste pris',
    bestFitForPrice: 'Bedste værdi for pengene',
    addToCartError: 'Føj til indkøbskurven var ikke vellykket. Prøv igen',
    addRoutineToCart: 'Tilføj til kurv',
    explanationHeader: 'Flere produktoplysninger:',
    emptyRoutineItem: 'Desværre er der ikke noget produkt i den kategori, der matcher dine præferencer.'
  },
  tabBar: {
    chat: 'Chat',
    productAdvisor: 'Produktrådgiver'
  },
  recommender: {
    answerOptionLeadsToNoRecommendation: 'Desværre ville denne mulighed ikke føre til noget ønsket produkt. Du kan ændre din præference i tidligere trin for at aktivere indstillingen.'
  }
}
